import { useEffect, useState } from 'react';
import { logout, submitReverifyCode, useReverifyState } from '../lib/api.jsx';

// ─── Modale « Code de vérification » ──────────────────────────
// Montée par App.jsx au-dessus de tout écran (chargement, tableau de bord, visionneuse).
// Ouverte par lib/api.jsx quand le jeton de 12 h expire : une seule demande en
// vol, partagée par tous les appels en attente.
export function ReverifyModal() {
  const { open, error, busy } = useReverifyState();
  const [code, setCode] = useState('');

  useEffect(() => {
    if (!open) setCode('');
  }, [open]);

  if (!open) return null;

  const submit = () => {
    if (code.length === 6 && !busy) submitReverifyCode(code);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="reverify-title"
        className="bg-card border border-rule rounded-2xl p-7 w-[380px] max-w-full"
      >
        <div id="reverify-title" className="text-lg font-bold text-fg mb-1.5">
          Code de vérification
        </div>
        <div className="text-[13px] text-muted mb-4">
          Votre session doit être revérifiée (toutes les 12 h). Entrez le code à 6 chiffres de votre appli
          d'authentification.
        </div>
        {error && <div className="text-crit text-xs mb-3 text-center">{error}</div>}
        <input
          className="w-full px-3.5 py-2.5 mb-4 bg-sidebar border border-rule rounded-lg text-fg-2 text-center text-[22px] font-mono tracking-[8px] outline-none box-border focus:border-blue-500"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          maxLength={6}
          inputMode="numeric"
          autoComplete="one-time-code"
          autoFocus
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />
        <button
          onClick={submit}
          disabled={busy || code.length !== 6}
          className="w-full py-3 rounded-[9px] border-none bg-blue-500 text-white text-sm font-semibold cursor-pointer disabled:opacity-60 hover:bg-blue-600 transition-colors"
        >
          {busy ? 'Vérification...' : 'Vérifier'}
        </button>
        <button
          onClick={() => logout()}
          className="w-full py-3 rounded-[9px] bg-transparent border border-rule-3 text-muted text-sm font-semibold cursor-pointer mt-2 hover:bg-card-hi"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
}
